import type { Plan } from "@cliently/types";

/** Plan minimum pour invitations, rôles et retrait de membres (aligné API + garde client). */
export const TEAM_MANAGEMENT_REQUIRED_PLAN = "BUSINESS" as const satisfies Plan;



export const isBusinessPlanForTeam = (plan: string | undefined | null): plan is typeof TEAM_MANAGEMENT_REQUIRED_PLAN => {
  return plan === TEAM_MANAGEMENT_REQUIRED_PLAN;
}



/** À appeler avant toute mutation « équipe » côté client (API ouverte ou non). */
export const assertBusinessPlanForTeam = (plan: string | undefined | null): void => {
  if (!isBusinessPlanForTeam(plan)) {
    throw new Error(
      "La gestion d'équipe est réservée au plan Business.",
    );
  }
}
